"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/formatters/MXPIcon";
import { StarRating } from "../StarRating/StarRating";
import { TerraLink } from "../TerraLink/TerraLink";
import { ContentfulImage } from "../ContentfulImage/ContentfulImage";
export interface TestimonialLogo {
  url: string;
  width: number;
  height: number;
  alt?: string;
}
export interface TestimonialCta {
  label?: string;
  destination?: string;
  ariaLabel?: string;
}
export interface TestimonialTag {
  id: string;
  label: string;
}
export interface Testimonial {
  quote?: string;
  attributionName?: string;
  attributionQualification?: string;
  rating?: number;
  logo?: TestimonialLogo;
  logoDestination?: string;
  cta?: TestimonialCta;
  tags?: TestimonialTag[];
}
const TAG_CHIP_CLASSES = "inline-block rounded bg-gray-m1 px-3 py-1 text-xs font-bold uppercase leading-4 tracking-wide text-gray-m9 t2-dark:bg-gray-m8 t2-dark:text-white";

/** Contentful caps the tags field at 3; enforced here so overflow can't break the row. */
const MAX_TAGS = 3;
export const Testimonial = t0 => {
  const $ = _c(57);
  const {
    quote,
    attributionName,
    attributionQualification,
    rating,
    logo,
    logoDestination,
    cta,
    tags
  } = t0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== attributionName || $[1] !== attributionQualification || $[2] !== cta || $[3] !== logo || $[4] !== logoDestination || $[5] !== quote || $[6] !== rating || $[7] !== tags) {
    const visibleTags = (tags ?? []).filter(_temp).filter(_temp2).slice(0, MAX_TAGS);
    const hasLogo = Boolean(logo?.url);
    let t11;
    if ($[18] !== attributionName) {
      t11 = attributionName?.trim();
      $[18] = attributionName;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    const hasName = Boolean(t11);
    let t12;
    if ($[20] !== attributionQualification) {
      t12 = attributionQualification?.trim();
      $[20] = attributionQualification;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    const hasQualification = Boolean(t12);
    const isQuoteOnly = !(typeof rating === "number" && rating > 0) && !hasLogo && !(cta?.label && cta?.destination) && visibleTags.length === 0;
    let t13;
    if ($[22] !== hasLogo || $[23] !== logo) {
      t13 = hasLogo ? <ContentfulImage src={logo.url} alt={logo.alt || ""} width={logo.width} height={logo.height} className="h-10 w-auto max-h-10 object-contain" /> : null;
      $[22] = hasLogo;
      $[23] = logo;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const logoImage = t13;
    t9 = `t2-testimonial relative mx-5 my-4 overflow-hidden rounded-lg bg-white px-8 py-10 shadow-[0_4px_20px_rgba(0,0,0,0.08)] min-[600px]:mx-auto min-[600px]:mb-20 min-[600px]:mt-0 min-[600px]:px-16 t2-dark:bg-gray-m7 t4:bg-white ${isQuoteOnly ? "min-[600px]:py-28" : ""}`;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div aria-hidden="true" className="absolute left-0 top-0 h-2.5 w-full bg-blue-trmb min-[600px]:h-full min-[600px]:w-2.5" />;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t6 = "min-[600px]:grid min-[600px]:grid-cols-[auto_1fr] min-[600px]:items-start min-[600px]:gap-x-4";
    if ($[26] !== rating) {
      t7 = typeof rating === "number" && rating > 0 && <div className="mb-6 min-[600px]:col-start-2"><StarRating rating={rating} /></div>;
      $[26] = rating;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="mb-5 text-gray-m10 [&_svg]:h-8 [&_svg]:w-8 min-[600px]:mb-0 min-[600px]:mt-1 min-[600px]:[&_svg]:h-10 min-[600px]:[&_svg]:w-10 t2-dark:brightness-0 t2-dark:invert t4:brightness-100 t4:invert-0" aria-hidden="true"><Icon type="t2u-quotation" size={40} /></div>;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    t1 = "min-w-0";
    if ($[29] !== quote) {
      t2 = quote && <p className="mb-8 text-base font-normal leading-7 text-gray-m9 min-[600px]:text-xl min-[600px]:leading-8 t2-dark:text-white t4:text-gray-m9">{quote}</p>;
      $[29] = quote;
      $[30] = t2;
    } else {
      t2 = $[30];
    }
    if ($[31] !== attributionName || $[32] !== attributionQualification || $[33] !== hasLogo || $[34] !== hasName || $[35] !== hasQualification || $[36] !== logo?.alt || $[37] !== logoDestination || $[38] !== logoImage) {
      t3 = (hasName || hasQualification || hasLogo) && <div className="flex items-center justify-between gap-8"><div className="flex min-w-0 flex-col text-base leading-snug text-gray-m9 min-[600px]:flex-row min-[600px]:items-center t2-dark:text-white t4:text-gray-m9">{hasName && <span className="font-bold">{attributionName}</span>}{hasName && hasQualification && <span className="mx-2.5 hidden h-4 w-px shrink-0 bg-gray-m3 min-[600px]:inline-block t2-dark:bg-white t4:bg-gray-m3" aria-hidden="true" />}{hasQualification && <span className="font-normal">{attributionQualification}</span>}</div>{hasLogo && <div className="ml-auto hidden shrink-0 min-[600px]:block" data-testid="testimonial-logo">{logoDestination ? <TerraLink destination={logoDestination} linkType="text" disableStyles={true} className="inline-block" ariaLabel={logo?.alt || "Company logo"}>{logoImage}</TerraLink> : logoImage}</div>}</div>;
      $[31] = attributionName;
      $[32] = attributionQualification;
      $[33] = hasLogo;
      $[34] = hasName;
      $[35] = hasQualification;
      $[36] = logo?.alt;
      $[37] = logoDestination;
      $[38] = logoImage;
      $[39] = t3;
    } else {
      t3 = $[39];
    }
    if ($[40] !== cta) {
      t4 = cta?.label && cta?.destination && <div className="mt-8" data-testid="testimonial-cta"><TerraLink label={cta.label} destination={cta.destination} ariaLabel={cta.ariaLabel} linkType="text" isIcon={true} className="items-center text-base font-semibold text-blue-trmb no-underline hover:text-blue-navy t2-dark:text-blue-sky t4:text-blue-trmb [&_.t2-icon]:ml-3" /></div>;
      $[40] = cta;
      $[41] = t4;
    } else {
      t4 = $[41];
    }
    t5 = visibleTags.length > 0 && <ul className="mt-10 flex list-none flex-row flex-wrap gap-2 m-0 p-0 min-[600px]:mt-8" data-testid="testimonial-tags">{visibleTags.map(_temp3)}</ul>;
    $[0] = attributionName;
    $[1] = attributionQualification;
    $[2] = cta;
    $[3] = logo;
    $[4] = logoDestination;
    $[5] = quote;
    $[6] = rating;
    $[7] = tags;
    $[8] = t1;
    $[9] = t10;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t1 = $[8];
    t10 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[42] !== t1 || $[43] !== t2 || $[44] !== t3 || $[45] !== t4 || $[46] !== t5) {
    t11 = <div className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[42] = t1;
    $[43] = t2;
    $[44] = t3;
    $[45] = t4;
    $[46] = t5;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  let t12;
  if ($[48] !== t11 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8) {
    t12 = <div className={t6}>{t7}{t8}{t11}</div>;
    $[48] = t11;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  let t13;
  if ($[53] !== t10 || $[54] !== t12 || $[55] !== t9) {
    t13 = <div className={t9}>{t10}{t12}</div>;
    $[53] = t10;
    $[54] = t12;
    $[55] = t9;
    $[56] = t13;
  } else {
    t13 = $[56];
  }
  return t13;
};
function _temp(tag) {
  return tag.label?.trim();
}
function _temp2(tag_0, index, list) {
  return list.findIndex(t => t.id === tag_0.id) === index;
}
function _temp3(tag_1) {
  return <li key={tag_1.id}><span className={TAG_CHIP_CLASSES}>{tag_1.label}</span></li>;
}